import HooksCore from '@/store/_core/_hooks';
import Hooks from '@/store/_hooks';

export default async (context) => {
  const hooksCore = new HooksCore(context);
  await hooksCore.handle();

  const hook = new Hooks(context);
  await hook.handle();
};
